export default "__VITE_ASSET__B5mC9ZBN__"